import React, { useCallback } from "react";
import { useRemoteSensors } from "@/hooks/useRemoteSensors";
import WSMSensorLocation from "@WahooFitness/wsm-native/dist/esm/types/sensor_location";
import { MenuList, MenuListItemVariant } from "@WahooFitness/redesignr";
import { t, Trans } from "@lingui/macro";
import { Box } from "@mui/system";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";

interface BodyPositionConfigProps {
  appToken: string;
  remoteSensorId: number;
}

const BodyPositionConfig = ({ appToken, remoteSensorId }: BodyPositionConfigProps) => {
  const { remoteSensorStatus, saveRemoteSensorConfig } = useRemoteSensors(appToken);

  const handleLocationChange = useCallback(
    (_event: React.MouseEvent<HTMLElement>, newLocation: string | null) => {
      if (!newLocation) return;

      const newLocationValue =
        newLocation === "Upper back" ? WSMSensorLocation.UPPER_BACK : WSMSensorLocation.UPPER_ARM;
      saveRemoteSensorConfig(remoteSensorId, { sensor_location: newLocationValue });
    },
    [saveRemoteSensorConfig, remoteSensorId]
  );

  if (!remoteSensorStatus) {
    return null;
  }

  const remoteSensor = remoteSensorStatus?.sensors?.find(
    (sensor) => sensor?.cfg?.sensor_id === remoteSensorId
  );

  const sensorLocation = remoteSensor?.cfg?.sensor_location;
  const sensorLocationValid =
    sensorLocation !== undefined &&
    [WSMSensorLocation.UPPER_BACK, WSMSensorLocation.UPPER_ARM].includes(sensorLocation);

  return (
    <MenuList
      listItems={[
        {
          id: "body_position_config",
          content: t`Body position`,
          hidden: !sensorLocationValid,
          variant: MenuListItemVariant.NoAction,
          secondaryContent: (
            <Box display="flex" flexDirection="column" rowGap={1} mt={1}>
              <ToggleButtonGroup
                exclusive
                fullWidth
                value={sensorLocation === WSMSensorLocation.UPPER_BACK ? "Upper back" : "Upper arm"}
                onChange={handleLocationChange}
              >
                <ToggleButton value={"Upper arm"}>
                  <Trans>Upper arm</Trans>
                </ToggleButton>
                <ToggleButton value={"Upper back"}>
                  <Trans>Upper back</Trans>
                </ToggleButton>
              </ToggleButtonGroup>
            </Box>
          ),
        },
      ]}
      disableGutters
    />
  );
};

export { BodyPositionConfig };
